import { DatePipe } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertsService } from 'src/app/alerts.service';
import { EventsService } from 'src/app/services/events.service';

@Component({
  selector: 'app-detail-page',
  templateUrl: './detail-page.component.html',
  styleUrls: ['./detail-page.component.scss']
})
export class DetailPageComponent implements OnInit {
  pgIndex: number = 0;
  dataSource: any = null;
  pageLength: number;
  @Input() customer: any;
  displayedColumns = ["class_date", "day", "status", "id"];
  constructor(
    private scheduleService: EventsService,
    private alertsService: AlertsService,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.getScheduleDetailList(this.data.schedule.id);
  }

  getFormattedDates(): string {
    const startDate = this.datePipe.transform(this.data.schedule.start_date, 'dd-MM-yyyy');
    const endDate = this.datePipe.transform(this.data.schedule.end_date, 'dd-MM-yyyy');
    const days = this.data.schedule.day.join(',');
    return `${startDate} - ${endDate} - ( ${days}  ) `;
  }

  getScheduleDetailList(scheduler_id) {
    this.scheduleService.getSchedulesDetailList(scheduler_id, this.pgIndex).subscribe((data: any) => {
      if (data.returnCode === 200) {
        this.dataSource = data.result;
        this.pageLength = data.count;
      } else {
        this.alertsService.error(this.dataSource.message);
      }
    });
  }

  cancelClass(schedule_detail_id) {
    let data = { id: schedule_detail_id, status: "CANCELLED" };
    this.scheduleService.updateScheduleDetails(data).subscribe((data: any) => {
      if (data.returnCode === 200) {
        this.getScheduleDetailList(this.data.schedule.id);
      } else {
        this.alertsService.error(this.dataSource.message);
      }
    });
  }
}
